<template>
  <div class="p-2 border-bottom">
    <div class="d-flex">
      <div class="flex-grow-1">
        <h4>Instructions</h4>
      </div>
      <div v-if="!editing">
        <b-button variant="outline-secondary" size="md" title="edit question" @click="edit()"><i class="fa fa-edit" ></i></b-button>
      </div>
    </div>
    <div class="d-flex">
      <div class="flex-grow-1">
        <div>
          <wysiwyg v-if="editing"
                   :class="{ 'is-invalid' : apiErrors && apiErrors.length, 'disabled' : saving }"
                   v-model="innerModel.instructions"/>
          <validation-errors :validation-errors="apiErrors"/>

          <div v-if="!editing" class="form-control-static" v-html="kc.instructions"></div>
        </div>
        <div v-if="editing" class="ml-auto text-center p-2">
          <b-button :disabled="saving" @click.stop="cancel()">Cancel</b-button>
          <b-button :disabled="saving" variant="primary" @click.stop="save()">Save</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex'
import validationErrors from '@/components/common/form/validation-errors'
import api from '@/api/knowledgechecks/topic-knowledgecheck.js'

export default {
  components:{
    validationErrors
  },
  props:{
    kc: {type:null, default:''}
  },
  data(){
    return{
      editing: false,
      saving: false,
      apiErrors: [],
      innerModel: {}
    }
  },
  computed:{
    ...mapState('tenants', {
      organization: 'current'
    }),
    ...mapState('topics', {
      topic: 'current'
    }),
    id(){
      return this.kc.id
    }
  },
  methods:{
    cancel(){
      this.editing = false
    },
    edit(){
      this.editing = true
      this.innerModel.id = this.kc.id
      this.innerModel.instructions = this.kc.instructions
    },
    async save(){
      this.saving = true

      const params = {
        tenantId: this.organization.id,
        topicId: this.topic.id,
        data: {id: this.kc.id, instructions: this.innerModel.instructions}
      }

      if(!this.kc.id){
        const response = await api.store(params)
        this.innerModel.id = response.data.data.id
        this.innerModel.questions = []
      }
      else{
        params.knowledgecheckId = this.kc.id
        await api.update(params)
      }

      this.saving = false
      this.editing = false
      this.$emit('updated', this.innerModel)
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/instructions.vue